(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.snapshopHeroReady === 'true') return;
    hero.dataset.snapshopHeroReady = 'true';

    if (!hero.classList.contains('snapshop-hero--reveal')) {
      hero.classList.add('is-visible');
      return;
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      hero.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        hero.classList.add('is-visible');
        observer.unobserve(hero);
      });
    }, {
      threshold: 0.12
    });

    observer.observe(hero);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-snapshop-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
